import React from 'react';
import './Booking-select.css';

const BookingSelect = ({ title, icon, value, onChange, error }) => {
  return (
    <div className="Booking-input-contanir">
      <h4 className="Booking-input-text1">{title}</h4>
      <div className="Booking-input-wrapper">
        {icon && <span className="Booking-input-icon-wrap">{icon}</span>}
        <div className="Booking-select-wrapper" style={{ width: '100%' }}>
          <select className={`Booking-select-div ${error ? 'input-error' : ''}`} value={value} onChange={onChange}>
            <option value="" disabled>Select ticket category</option>
            <option value="Standard Access">Standard Access — 250 EGP</option>
            <option value="VIP Access">VIP Access — 500 EGP</option>
            <option value="Collector's Pass">Collector's Pass — 1000 EGP</option>
          </select>
          <span className="Booking-select-arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M6 9L12 15L18 9" stroke="rgba(214, 184, 147, 0.70)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
      {error && <span className="input-error-text">{error}</span>}
    </div>
  );
};

export default BookingSelect;